import { param } from "jquery";
import { ContentTable, TDocumentDefinitions } from "pdfmake/interfaces";
import HeaderSummaryReportForm from "react-lib/apps/HISV3/BIL/pdfFormBil/HeaderSummaryReportForm";
import CompanyLogoForm from "react-lib/apps/HISV3/common/CompanyLogoForm";

const FORM_NAME = "FormReceiptReturn";

// Types
type FormReceiptReturnProps = {
  params?: any;
  fields?: any;
};

const FormReceiptReturn = async (props: FormReceiptReturnProps) => {
  const companyLogoForm = await CompanyLogoForm({
    font: "THSarabunNew",
    height: 40,
    form: FORM_NAME,
  });
  const { font, images } = companyLogoForm;

  const fileData = (props.fields || []).map((item: any, index: number) => {
    return [
      {
        text: item?.seq || index + 1,
        style: {
          alignment: "center",
        },
      },
      {
        text: item?.station || "",
        style: {
          alignment: "center",
        },
      },
      {
        text: item?.receipt_number || "",
        style: {
          alignment: "center",
        },
      },
      {
        text: item?.return_note || "",
        style: {
          alignment: "center",
        },
      },
      {
        text: item?.return_user_name || "",
        margin: [5, 0, 5, 0],
      },
      {
        text: item?.return_datetime || "",
        style: {
          alignment: "center",
        },
      },
    ];
  });

  return {
    defaultStyle: {
      font: font,
      fontSize: 13,
    },
    pageSize: "A4",
    pageMargins: [10, 133, 10, 10],
    header: function (currentPage: any) {
      return {
        margin: [5, 13, 5, 0],
        stack: [
          // header
          {
            margin: [10, 0, 12, 0],
            table: {
              widths: [120, "*", 160],
              body: [
                [
                  {
                    image: "logo",
                    width: 120,
                    height: 36,
                    border: [false, false, false, false],
                    alignment: "left",
                    margin: [0, 8, 0, 0],
                  },
                  {
                    stack: [
                      {
                        text: "รายงาน Return ใบเสร็จ",
                        style: {
                          bold: true,
                          fontSize: 18,
                          alignment: "center",
                        },
                      },
                      {
                        text: `ประจำวันที่: ${props.params?.start_date || "-"} ถึง ${
                          props.params?.end_date || "-"
                        }`,
                        style: {
                          alignment: "center",
                        },
                      },
                    ],
                    margin: [0, 8, 0, 0],
                    border: [false, false, false, false],
                  },
                  {
                    stack: [
                      {
                        columns: [
                          {
                            text: `ผู้พิมพ์:`,
                            style: {
                              bold: true,
                              fontSize: 12,
                            },
                            width: 40,
                          },
                          {
                            text: `${props.params?.print_user}`,
                            style: {
                              fontSize: 12,
                            },
                          },
                        ],
                      },
                      {
                        columns: [
                          {
                            text: `วันที่พิมพ์:`,
                            style: {
                              bold: true,
                              fontSize: 12,
                            },
                            width: 40,
                          },
                          {
                            text: `${props.params?.print_date_time}`,
                            style: {
                              fontSize: 12,
                            },
                          },
                        ],
                      },
                    ],
                    margin: [0, 10, 0, 0],
                    border: [false, false, false, false],
                  },
                ],
              ],
            },
          },
          {
            margin: [12, 25, 12, 0],
            table: {
              widths: [40, 50, 55, "*", "*", 75],
              body: [
                [
                  {
                    text: "ลำดับ",
                    style: {
                      alignment: "center",
                    },
                    margin: [0, 8, 0, 0],
                    border: [true, true, true, false]
                  },
                  {
                    text: "Station",
                    style: {
                      alignment: "center",
                    },
                    margin: [0, 8, 0, 0],
                    border: [true, true, true, false]
                  },
                  {
                    text: "เลขที่ใบเสร็จ\nที่ Return",
                    style: {
                      alignment: "center",
                    },
                    border: [true, true, true, false]
                  },
                  {
                    text: "เหตุผลการ\n Return ใบเสร็จ",
                    style: {
                      alignment: "center",
                    },
                    border: [true, true, true, false]
                  },
                  {
                    text: "เจ้าหน้าที่ผู้ Return",
                    style: {
                      alignment: "center",
                    },
                    margin: [0, 8, 0, 0],
                    border: [true, true, true, false]
                  },
                  {
                    text: "วันและเวลา\nที่ทำการ Return",
                    style: {
                      alignment: "center",
                    },
                    border: [true, true, true, false]
                  },
                ],
              ],
            },
          },
        ],
      };
    },
    content: [
      {
        margin: [7, 0, 7, 0],
        stack: [
          //data
          {
            table: {
              widths: [40, 50, 55, "*", "*", 75],
              body: [...fileData],
            },
          },
        ],
      },
      {
        margin: [7, 5, 7, 0],
        columns: [
          {
            text: ``,
            width: 40,
          },
          {
            text: `รวมทั้งสิ้น ${props.params?.total_receipt} รายการ`,
          },
        ],
      },
      {
        margin: [7, 0, 34, 0],
        table: {
          widths: [45, 145, "*", 45, 145],
          body: [
            [
              {
                text: "ผู้ส่งเอกสาร",
                style: {
                  alignment: "right",
                  fontSize: 12,
                },
                margin: [0, 10, 5, 0],
                border: [false, false, false, false],
              },
              {
                text: props.params?.print_user || "",
                style: {
                  alignment: "center",
                  fontSize: 12,
                },
                margin: [0, 10, 0, 0],
                border: [false, false, false, true],
              },
              {
                text: "",
                style: {
                  fontSize: 12,
                },
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
              },
              {
                text: "ผู้รับเอกสาร",
                style: {
                  alignment: "right",
                  fontSize: 12,
                },
                margin: [0, 10, 5, 0],
                border: [false, false, false, false],
              },
              {
                text: "",
                style: {
                  alignment: "center",
                  fontSize: 12,
                },
                margin: [0, 10, 0, 0],
                border: [false, false, false, true],
              },
            ],
            [
              {
                text: "วันที่",
                style: {
                  alignment: "right",
                  fontSize: 12,
                },
                margin: [0, 10, 5, 0],
                border: [false, false, false, false],
              },
              {
                text: props.params?.print_date_time || "",
                style: {
                  alignment: "center",
                  fontSize: 12,
                },
                margin: [0, 10, 0, 0],
                border: [false, false, false, true],
              },
              {
                text: "",
                style: {
                  fontSize: 12,
                },
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
              },
              {
                text: "วันที่",
                style: {
                  alignment: "right",
                  fontSize: 12,
                },
                margin: [0, 10, 5, 0],
                border: [false, false, false, false],
              },
              {
                text: "",
                style: {
                  alignment: "center",
                  fontSize: 12,
                },
                margin: [0, 10, 0, 0],
                border: [false, false, false, true],
              },
            ],
          ],
        },
        layout: {
          paddingTop: function (i: any, node: any) {
            return 0;
          },
          paddingBottom: function (i: any, node: any) {
            return 0;
          },
        },
      },
    ],
    styles: {},
    images: {
      ...images,
    },
  };
};

export default FormReceiptReturn;
